<template>
    <div class="balance-holder">
        <b-button
            icon-left="plus-circle"
            :size="size"
            @click="openCreditModal"
            class="is-inverted is-info balance-button"
            :class="{ 'is-low-balance': isLow(credits) }">
            {{ credits == undefined ? '??' : credits }} <img class="currency-icon" src="@/assets/images/currency/128w/credits.png" />
        </b-button>
        <b-button
            icon-left="plus-circle"
            :size="size"
            @click="openGoldModal"
            class="is-inverted is-warning balance-button">
            {{ gold == undefined ? '??' : gold }} <img class="currency-icon" src="@/assets/images/currency/coin.gif" />
        </b-button>
    </div>
</template>

<style lang="scss">
.balance-holder {
    .balance-button {
        margin-right: 0.5rem;
    }
    .icon, .currency-icon {
        vertical-align: bottom;
    }
    .is-small .currency-icon {
        height: 1rem;
    }
    // A quiet nudge, not a popup — a soft ring around the balance pill when
    // it's running low, so the "+" is easier to notice without interrupting.
    .is-low-balance {
        box-shadow: 0 0 0 2px rgba(255, 221, 87, 0.9);
    }
}
</style>

<script>
export default {
    name: 'NavBalance',
    props: {
        credits: Number,
        gold: Number,
        size: String,
    },
    methods: {
        isLow(balance) {
            return typeof balance === 'number' && balance < 100
        },
        openCreditModal() {
            this.$store.commit('setModalItems', 'credits')
            this.$store.commit('togglePurchaseModal')
        },
        openGoldModal() {
            this.$store.commit('setModalItems', 'gold')
            this.$store.commit('togglePurchaseModal')
        }
    }
}
</script>